/**
 * Altura da faixa única do composer (uma linha de texto, gravação ou preview de áudio).
 * Mantém o mesmo valor em todos os estados para evitar “pulo” visual ao trocar texto ↔ áudio.
 * Valor alinhado ao `MuiInputBase-root` do TextField multiline (1 linha) no tema atual (~65px).
 */
export const COMPOSER_ROW_HEIGHT_PX = 65;

/** Mesmo recorte do chat (`useChatState`) — composer/header mobile não devem afetar desktop. */
export const COMPOSER_MOBILE_MEDIA_QUERY = "(max-width: 768px)";

/** Faixa única no telefone: campo + ações + enviar. */
export const COMPOSER_MOBILE_ROW_HEIGHT_PX = 44;

/** Botão circular de enviar/gravar ao lado do composer. */
export const COMPOSER_ACTION_BUTTON_SIZE_PX = 40;

/** Enviar/gravar compacto no telefone. */
export const COMPOSER_MOBILE_ACTION_BUTTON_SIZE_PX = 34;

/** Uma linha só: campo, ícones e enviar, sem faixa extra embaixo. */
export const composerMobileInputRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 0.25,
  width: "100%",
  minWidth: 0,
};

export const composerPrimaryActionButtonSx = ({
  accent = null,
  accentHover = null,
  size = COMPOSER_ACTION_BUTTON_SIZE_PX,
} = {}) => ({
  flexShrink: 0,
  alignSelf: "center",
  width: size,
  height: size,
  p: 0,
  borderRadius: "50%",
  backgroundColor: accent || "primary.main",
  color: "primary.contrastText",
  "&:hover": {
    backgroundColor: accentHover || "primary.dark",
  },
  "&.Mui-disabled": {
    backgroundColor: "action.disabledBackground",
    color: "action.disabled",
  },
});

export const composerSecondaryActionButtonSx = () => ({
  flexShrink: 0,
  alignSelf: "center",
  width: COMPOSER_ACTION_BUTTON_SIZE_PX,
  height: COMPOSER_ACTION_BUTTON_SIZE_PX,
  p: 0,
  borderRadius: "50%",
  border: 1,
  borderColor: "divider",
  color: "text.secondary",
  bgcolor: "background.paper",
  "&:hover": {
    bgcolor: "action.hover",
  },
});
